import React from "react";
import { Header, SlideLayout, Text } from "../../shared-components";
import aiSummary from "./assets/ai-summary.svg";

const Image = () => {
  return <img src={aiSummary} className="cw-w-full md:cw-h-[475px] cw-mt-3" />;
};

export const AISchedulerSlide = () => {
  return (
    <SlideLayout>
      <Header>Meet your calendar assistant</Header>
      <Text>
        Clockwise allows you to delegate calendar management with intelligent scheduling and
        automation.
      </Text>
      <Image />
    </SlideLayout>
  );
};
